import { render, staticRenderFns } from "./PageErrorNotFound.vue?vue&type=template&id=33ddb4ff&"
import script from "./PageErrorNotFound.vue?vue&type=script&lang=js&"
export * from "./PageErrorNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports